
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Onedaytripnearbhandara() {



  const cardData =
  {
    keyword: ' One Day Trip Near Bhandara',
    heading:  'Woodland Escape: One Day Trip Near Bhandara ',
    headingDescription: 'Woodland Escape Resort, an ideal destination for a one day trip near Bhandara, offers the perfect mix of adventure, relaxation, and natural beauty just a short drive from the city. Nestled amidst lush greenery, serene forest areas, and open lawns, the resort provides a refreshing escape for families, friends, and corporate groups. Guests can enjoy exciting activities such as ziplining, trekking, archery, cycling, swimming, and outdoor games, or simply unwind in scenic picnic spots and tranquil corners of the resort. With cozy cottages, delicious meals, and attentive hospitality, Woodland Escape Resort near Bhandara ensures your one-day trip is filled with fun, comfort, and memorable experiences in the heart of nature.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "One Day Trip Near Bhandara",
"description": "Plan a perfect one-day trip near Bhandara with scenic locations, outdoor activities, and leisure spots. Ideal for a refreshing day away from the city hustle."
},
{
"name": "Bhandara Day Tour",
"description": "Enjoy a full day tour around Bhandara, exploring natural landscapes, riversides, and cultural attractions while relaxing and rejuvenating in a scenic setting."
},
{
"name": "Bhandara Local Sightseeing Trip",
"description": "Discover local attractions in Bhandara with a guided sightseeing trip covering historical sites, parks, gardens, and nature spots suitable for all age groups."
},
{
"name": "Bhandara Short Excursion",
"description": "Take a short excursion from Bhandara to nearby scenic spots, offering a quick yet refreshing escape with opportunities for photography, nature walks, and relaxation."
},
{
"name": "Affordable One Day Trip Bhandara",
"description": "Enjoy an affordable one-day trip option in Bhandara with all essential amenities, guided tours, and recreational activities for a budget-friendly experience."
},
{
"name": "Bhandara Nearby Attractions Trip",
"description": "Explore the best nearby attractions of Bhandara in a single day tour, combining nature, heritage, and leisure for a fulfilling day out."
},
{
"name": "Bhandara Weekend Day Trip",
"description": "Plan your weekend escape with a day trip in Bhandara, featuring outdoor activities, picnic spots, and nature walks to refresh your mind and body."
},
{
"name": "Bhandara Family Day Trip",
"description": "Perfect for families, this Bhandara day trip includes kid-friendly activities, open spaces, and relaxing stops for a memorable family outing."
},
{
"name": "Bhandara Nature Day Trip",
"description": "Immerse yourself in nature with a one-day tour around Bhandara’s lush landscapes, gardens, and riverside spots, ideal for eco-lovers and photographers."
},
{
"name": "Bhandara Riverside Trip",
"description": "Relax by the riversides of Bhandara during your day trip, enjoying serene water views, picnic options, and outdoor fun activities for a rejuvenating experience."
},
{
"name": "Bhandara Hill One Day Tour",
"description": "Explore the scenic hills around Bhandara on a one-day tour, perfect for hiking enthusiasts, adventure seekers, and those looking for panoramic views."
},
{
"name": "Bhandara Excursion Packages",
"description": "Choose from specially curated excursion packages in Bhandara, including sightseeing, guided tours, meals, and leisure activities for a hassle-free experience."
},
{
"name": "Bhandara One Day Outing",
"description": "Enjoy a one-day outing in Bhandara with friends or family, combining sightseeing, outdoor activities, and relaxation at top scenic spots."
},
{
"name": "Bhandara Day Trip Booking",
"description": "Book your Bhandara day trip in advance to secure your spot, complete with itinerary, meals, guided activities, and comfortable transport options."
},
{
"name": "Bhandara Scenic Day Trip",
"description": "Experience a scenic day trip in Bhandara with breathtaking views, natural landscapes, rivers, and hills, perfect for photography and peaceful leisure."
}
],
"tableData": [
["- One Day Trip Near Bhandara", "- Bhandara Day Tour"],
["- Bhandara Local Sightseeing Trip", "- Bhandara Short Excursion"],
["- Affordable One Day Trip Bhandara", "- Bhandara Nearby Attractions Trip"],
["- Bhandara Weekend Day Trip", "- Bhandara Family Day Trip"],
["- Bhandara Nature Day Trip", "- Bhandara Riverside Trip"],
["- Bhandara Hill One Day Tour", "- Bhandara Excursion Packages"],
["- Bhandara One Day Outing", "- Bhandara Day Trip Booking"],
["- Bhandara Scenic Day Trip", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Ideal One Day Trip Near Bhandara",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect choice for a one‑day trip near Bhandara, offering a refreshing escape into nature without requiring an overnight stay. Set amidst lush forest surroundings, it invites you to enjoy a full day of scenic beauty, relaxation, and fun — all within easy reach from Bhandara."
  },
  {
    "WhyChooseheading": "Tranquil Forest Setting Near Bhandara",
    "WhyChoosedescription": "Located close to Bhandara, Woodland Escape Resort is surrounded by dense trees, clean air, and peaceful landscapes. The nature‑filled environment creates a calming backdrop for your day‑trip, providing a break from the city hustle."
  },
  {
    "WhyChooseheading": "Comfortable Day‑Use Facilities",
    "WhyChoosedescription": "Even for a day visit, comfort is key. Woodland Escape Resort offers well‑equipped day‑use zones — shady picnic areas, forest‑view sit‑outs, and rest spots. Whether you’re having lunch, relaxing between activities, or simply enjoying the forest ambience, you’ll be comfortable and relaxed."
  },
  {
    "WhyChooseheading": "Activities to Make Your Day Memorable",
    "WhyChoosedescription": "Spend your day at Woodland Escape Resort with a mix of fun and ease. Explore nature trails, stroll through the forest, cycle, try light adventure activities, or lounge by the pond. The resort offers options for all ages for a memorable one‑day outing."
  },
  {
    "WhyChooseheading": "Great for Family, Friends or Group Outings",
    "WhyChoosedescription": "Whether you’re planning a day out with family, friends, or a small group, Woodland Escape Resort provides the ideal backdrop. Its sprawling forest grounds, group‑friendly zones, and safe environment make it perfect for shared experiences and bonding."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "Your day gets better with tasty, freshly prepared meals and snacks from locally sourced ingredients. At Woodland Escape Resort, you’ll find options to keep everyone satisfied and energized as you enjoy the forest‑day experience."
  },
  {
    "WhyChooseheading": "Convenient Access from Bhandara",
    "WhyChoosedescription": "Located just a short scenic drive from Bhandara, Woodland Escape Resort is easily reachable for your day trip. Its proximity means you can maximize your time in nature and less time travelling."
  }
]
















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a one-day trip near Bhandara?",
    answer: "Woodland Escape Resort offers a scenic, peaceful, and accessible location ideal for a refreshing one-day trip near Bhandara. Guests can enjoy nature, outdoor activities, and relaxation all in a single day."
  },
  {
    question: "How far is Woodland Escape Resort from Bhandara city?",
    answer: "The resort is approximately 40–45 km from Bhandara, which takes around 1 to 1.5 hours by car. It’s a convenient distance for a day trip without long travel times."
  },
  {
    question: "What activities can we enjoy during a one-day trip?",
    answer: "Guests can indulge in nature walks, cycling, open-lawn games, picnic-style relaxation, and explore scenic spots within the resort. It’s designed for a mix of fun and calm experiences."
  },
  {
    question: "Is the one-day trip suitable for families and groups?",
    answer: "Yes! Woodland Escape Resort is family-friendly with safe outdoor spaces for children, shaded seating for adults, and group-friendly arrangements for friends and colleagues."
  },
  {
    question: "Are meals included in the one-day trip package?",
    answer: "Yes, the package can include welcome drinks, a wholesome lunch, snacks, and tea/refreshments, making your day outing convenient and enjoyable."
  },
  {
    question: "How can we book a one-day trip at Woodland Escape Resort near Bhandara?",
    answer: "You can book by contacting our reservations team via phone or WhatsApp, or visit the website to fill out the booking form. Advance booking is recommended, especially on weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Rajesh & Family, Bhandara",
    text: "We had an amazing one-day trip at Woodland Escape Resort! The kids loved the outdoor activities, the surroundings were peaceful, and the food was delicious. Perfect for a day out near Bhandara."
  },
  {
    name: "Miss. Shreya & Friends, Bhandara",
    text: "Our one-day visit to Woodland Escape Resort was fantastic! Beautiful green lawns, fun activities, and friendly staff made it an unforgettable experience. Highly recommended for a day trip near Bhandara."
  }
];
















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Day Trip Near Bhandara",
  "image": "https://woodlandescape.com/assets/images/one-day-trip-near-bhandara.jpg",
  "description": "Experience an exciting one day trip near Bhandara at Woodlandescape Resort. Enjoy nature, outdoor activities, scenic views, and a perfect day outing for families and friends.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "421"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1099",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/one-day-trip-near-bhandara"
  }
};





  return (
    <div>
<Helmet>
  <title>One Day Trip Near Bhandara | Scenic Day Out | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a memorable one day trip near Bhandara at Woodlandescape Resort. Enjoy nature, outdoor fun, scenic views, and a perfect day outing for families and friends." 
  />
  <meta 
    name="keywords" 
    content="One Day Trip Near Bhandara, Bhandara Day Tour, Bhandara Local Sightseeing Trip, Bhandara Short Excursion, Affordable One Day Trip Bhandara, Bhandara Nearby Attractions Trip, Bhandara Weekend Day Trip, Bhandara Family Day Trip, Bhandara Nature Day Trip, Bhandara Riverside Trip, Bhandara Hill One Day Tour, Bhandara Excursion Packages, Bhandara One Day Outing, Bhandara Day Trip Booking, Bhandara Scenic Day Trip" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/17.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onedaytripnearbhandara;